import axiosInstance from "@API/axios";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "@Redux/snackBarSlice";

const useSendGetRequest = (showSnackBar = false) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const getData = (url, params) => {
    setLoading(true);
    return axiosInstance
      .get(url, params)
      .then((response) => {
        setLoading(false);
        return response;
      })
      .catch((error) => {
        setLoading(false);
        if (showSnackBar) {
          let errorMsg = "Internal Server Error.";
          const data = error?.response?.data;

          if (typeof data === "object" && data?.details) {
            errorMsg = data.details;
          } else if (typeof data === "string") {
            errorMsg = data;
          }

          dispatch(
            setSnackbar({
              open: true,
              message: errorMsg,
              error: true,
            })
          );
        }
      });
  };
  return { loading, getData };
};

export default useSendGetRequest;
